export default __webpack_public_path__ + "static/MeshMark-Formula-36243800e2528b492229ebde75134376.webp";